import React from 'react';
import { documentToHtmlString } from '@contentful/rich-text-html-renderer';

export default contentText => {
  return <div dangerouslySetInnerHTML={{ __html: documentToHtmlString(contentText) }} />;
};
